var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.creating)?_c('CreateForm',{attrs:{"opportunity":_vm.opportunity}}):_c('EditForm',{attrs:{"opportunity":_vm.opportunity}})}
var staticRenderFns = []

export { render, staticRenderFns }